export default "__VITE_ASSET__f0e6c987__"